import axios, { AxiosInstance } from "axios";
import { decrypt } from "./encryption";
const baseURL = process.env.REACT_APP_BASE_URL;

const createAxiosInstance = (endpoint: string = "") => {
  const newInstance = axios.create({
    baseURL:
      endpoint === "kyp"
        ? process.env.REACT_APP_KYP_BASE_URL
        : endpoint === "wc-claims"
        ? process.env.REACT_APP_WC_CLAIMS_BASE_URL
        : `${baseURL}/${endpoint}`,
  });

  newInstance.interceptors.request.use(function (request) {
    const userDetails = localStorage.getItem("userDetails")!;
    if (userDetails) {
      const { method, data } = request;
      if (method === "post" && !data) request.data = {};
      let token = JSON.parse(decrypt(userDetails || ""))?.accessToken;
      request.headers.Authorization = `Bearer ${token}`;
      request.data.user = userDetails;
    }
    return request;
  });

  newInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        window.location.pathname !== "/login"
      ) {
        // Access Token was expired
        localStorage.removeItem("userDetails");
        window.location.pathname = "/login";
      }
      return Promise.reject(error);
    }
  );

  return newInstance;
};

const hrClient = createAxiosInstance("hr-bot");

const documentClient = createAxiosInstance("doc-analyzer");

const competitorClient = createAxiosInstance("competative-analysis");

const productClient = createAxiosInstance("product-catalogue/v2");

const legalClient = createAxiosInstance("legal");

const qcClient = createAxiosInstance("qc");

const kypClient = createAxiosInstance("kyp");

const wcClaimsClient = createAxiosInstance("wc-claims");

const baseClient = createAxiosInstance();

export const tools: Record<string, AxiosInstance> = {
  hr: hrClient,
  competitor: competitorClient,
  catalog: productClient,
  document: documentClient,
  help: documentClient,
  legal: legalClient,
  qc: qcClient,
  kyp: kypClient,
  "wc-claims": wcClaimsClient,
  default: baseClient,
};

export const getClient = (tool: string = "default") => {
  return tools[tool];
};

export const sendOTP = () => {
  const { data }: any = axios.post("https://otp-service.hdfcergo.com/sms/otp", {
    length: 4,
    templateName: "OTP_HDFC_ERGO",
    projectName: "CHASE",
    mobile: "7738184161",
  });
  return data;
};
export const verifyOTP = (payload: any) => {
  const { data }: any = axios.post(
    "https://otp-service.hdfcergo.com//sms/verifyOtp",
    {
      otp: payload,
      mobile: "7738184161",
      duration: 3,
    }
  );
  return data;
};
